import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../../core'
import * as goal from '../../goal'

export const RESOURCE = {
  payload: {
    modelId: goal.MODEL_ID,
    values: {
      // TODO: get multi-range to work
      // 'active_periods': new AtnMultirange<Date>(),
      [PartialId.Standard.create('active_periods')]: '{[1-1-2023,12-31-2024]}',
      [PartialId.Standard.create('code')]: '1.1.2',
      [PartialId.Standard.create('descr')]:
        'Provide students with the skillsets and competencies needed to thrive by shaping curricula that is mindful of employer, industry, and global/national challenges.',
      [PartialId.Standard.create('id')]: 'gmu_1_1_2',
      [PartialId.Standard.create('name')]:
        'Practical skillsets and competencies',
    },
  },
  type: core.quiver.Resource.Type.DmsRecord,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsRecord>
